import React from 'react';
import HeroImage from 'Components/home/widgets/HeroImage';
import { Link } from 'react-router-dom';
import SignInForm from 'Components/home/SignInForm';
import * as actions from 'Actions';
import { connect } from 'react-redux';
import Imgix from 'react-imgix';
import { getSettingByUrl } from 'HelperFunctions/StorefrontPage';
import classNames from 'classnames';

class SignIn extends React.Component {
  render() {
    const { errors, loginUser } = this.props;
    const { storefrontSetting, storefrontHomeSetting, theme } = this.props;

    const isElaina = theme === 'elaina';

    const { homeVisible, homeCarouselItems } = storefrontHomeSetting;
    const { pageBody, pageTitle, signinPicture } = storefrontSetting;
    const containsHomeImage = homeVisible && homeCarouselItems.length > 0;

    const defaultBody =
      'Track rentals, make payments, request changes. You name it!';
    const shouldNotDisplayFigure = isElaina && !containsHomeImage;

    return (
      <section
        className={classNames({
          signIn: true,
          authenticationNoImageContainer: shouldNotDisplayFigure,
        })}
      >
        {signinPicture ? (
          <figure>
            <Imgix
              src={signinPicture.imgixUrl}
              alt={pageTitle}
              width={1020}
              height={576}
            />
          </figure>
        ) : (
          <HeroImage shouldNotDisplayFigure={shouldNotDisplayFigure} />
        )}
        <div className={'details'}>
          <h1>{pageTitle || 'Sign In'}</h1>
          <p>{pageBody || defaultBody}</p>
        </div>
        <div className={'signInForm'}>
          <SignInForm errors={errors} onSubmit={loginUser} />
          <Link to='/forgotPassword'>Forgot Password</Link>
          <Link to='/signUp'>Sign Up for FREE!</Link>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { parsedStorefrontSettings } = state.locations;
  const {
    mainSetting: { theme },
  } = parsedStorefrontSettings;
  const { location } = state.locations;
  const { errors, loading } = state.auth;
  // const storefrontSetting = parsedStorefrontSettings.mainSetting;
  const storefrontSetting = getSettingByUrl(
    location.storefrontPages,
    ownProps.location.pathname
  );

  return {
    theme,
    errors,
    loading,
    storefrontSetting: parsedStorefrontSettings.storefrontSigninSetting,
    storefrontHomeSetting: parsedStorefrontSettings.storefrontHomeSetting,
  };
};

export default connect(mapStateToProps, actions)(SignIn);
